import ZoomImage from './zoomImage'

export default ZoomImage
